/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { requestBaseURL } from '@/config/serviceAPI';
import { getAxiosForClient } from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';
import { type RewardsAcknowledgeResponse, type PostRewardsAcknowlegeRequest } from '../interface';
import type { AxiosResponse } from 'axios';

const URL = `${requestBaseURL}/ecomm/b2c/v1/currentUser/rewards/acknowledge`;

type RewardsAcknowledgeProps = {
  onSuccess?: (data: RewardsAcknowledgeResponse) => void;
  onError?: (error: unknown, values: PostRewardsAcknowlegeRequest) => void;
  onMutate?: (values: PostRewardsAcknowlegeRequest) => void;
};

const selector = (
  response: AxiosResponse<RewardsAcknowledgeResponse>,
): RewardsAcknowledgeResponse => response.data;

const postRewardsAcknowledgement = async (values: PostRewardsAcknowlegeRequest) => {
  const response = await getAxiosForClient().post<RewardsAcknowledgeResponse>(URL, {
    ...values,
  });

  return selector(response);
};

export const usePostAcknowldegeMutation = (props?: RewardsAcknowledgeProps) => {
  const { onSuccess, onError, onMutate } = props ?? {};
  return useMutation({
    mutationFn: (requestProps: PostRewardsAcknowlegeRequest) =>
      postRewardsAcknowledgement(requestProps),
    onSuccess: (data) => onSuccess?.(data),
    onMutate: (data) => onMutate?.(data),
    onError: (error: unknown, values: PostRewardsAcknowlegeRequest) => onError?.(error, values),
  });
};
